export const primaryNavigation = () => ({
	navigationOpen: false,
	desktop: true,
	init() {
		this.handleResize();

		this.$watch("navigationOpen", (value) => {
			document.body.classList.toggle("primary-navigation-open", value);
		});
	},
	toggleMenu() {
		if (!this.navigationOpen) {
			const scrollbarWidth =
				window.innerWidth - document.documentElement.clientWidth;
			document.documentElement.style.setProperty(
				"--scrollbar-width",
				`${scrollbarWidth}px`,
			);
		}

		this.navigationOpen = !this.navigationOpen;
	},
	handleResize() {
		if (window.innerWidth >= 1024) {
			this.desktop = true; // Desktop view
		} else if (window.innerWidth < 1024 && this.desktop) {
			this.desktop = false; // Mobile view
		}
	},
});
